module.exports = __webpack_public_path__ + "img/winning_form-logo_white.73196200.svg";